<script setup>
// 서비스 소개 영역을 모듈화한 컴포넌트입니다.
</script>

<template>
  <div class="sections-container fade-in-up delay-300">
    
    <div class="section-group">
      <h3 class="section-header">탐험 (Explore)</h3>
      <div class="grid-container">
        <div class="card glass-panel col-span-3 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-red-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ff2e63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>
            </div>
            <span class="badge text-red">Discovery</span>
          </div>
          <h3>여정: 끝없는 지식의 파도</h3>
          <p>검색창을 넘어선 발견의 즐거움. AI가 실시간으로 생성하는 연관 주제를 따라, 꼬리에 꼬리를 무는 지식의 여정을 떠나보세요.</p>
          <router-link to="/journey" class="card-link text-red">여정 떠나기 →</router-link>
        </div>

        <div class="card glass-panel col-span-3 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-cyan-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00f3ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>
            </div>
            <span class="badge text-cyan">Feed</span>
          </div>
          <h3>누리: 세상의 모든 알짜 지식</h3>
          <p>방대한 정보의 홍수 속에서 핵심만 건져냈습니다. 200자 내외로 요약된 검증된 지식들을 SNS 피드처럼 가볍게 산책하듯 즐기세요.</p>
          <router-link to="/mining" class="card-link text-cyan">누리 구경하기 →</router-link>
        </div>

        <div class="card glass-panel col-span-3 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-purple-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#bc13fe" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>
            </div>
            <span class="badge text-purple">Archive</span>
          </div>
          <h3>갈무리: 나만의 인사이트</h3>
          <p>스쳐 지나가기 아까운 영감과 지식을 '갈무리'하세요. 단순한 저장을 넘어, 당신의 지적 자산이 쌓이는 디지털 서재가 됩니다.</p>
          <router-link to="/favorites" class="card-link text-purple">보관함 가기 →</router-link>
        </div>

        <div class="card glass-panel col-span-3 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-gray-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#b2bec3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            </div>
            <span class="badge text-gray">Search</span>
          </div>
          <h3>검색: 지식 탐험</h3>
          <p>말로만랩의 방대한 지식 콘텐츠를 검색하고 탐험하세요. 원하는 정보를 가장 빠르게 찾는 지름길입니다.</p>
          <router-link to="/search" class="card-link text-gray">검색하기 →</router-link>
        </div>
      </div>
    </div>

    <div class="section-group">
      <h3 class="section-header">경험 (Experience)</h3>
      <div class="grid-container">
        
        <div class="card glass-panel col-span-3 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-green-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2ed573" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"/><line x1="16" y1="8" x2="2" y2="22"/></svg>
            </div>
            <span class="badge text-green">Quiz</span>
          </div>
          <h3>슬기: 지혜를 증명하는 시간</h3>
          <p>눈으로만 본 지식은 내 것이 아닙니다. 다양한 난이도의 퀴즈를 풀며 당신의 이해도를 점검하세요.</p>
          <router-link to="/quiz" class="card-link text-green">일반 퀴즈 시작 →</router-link>
        </div>

        <div class="card glass-panel col-span-3 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-orange-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffa502" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            </div>
            <span class="badge text-orange">Speed</span>
          </div>
          <h3>재치: 찰나의 승부</h3>
          <p>긴박한 승부! 당신의 순발력과 직관을 테스트하세요. 빠른 판단으로 문제를 해결하고 짜릿함을 느껴보세요.</p>
          <router-link to="/speedquiz" class="card-link text-orange">스피드 퀴즈 시작 →</router-link>
        </div>

        <div class="card glass-panel col-span-3 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-pink-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ff7979" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
            </div>
            <span class="badge text-pink">Scratch</span>
          </div>
          <h3>야금: 은박 속의 진실</h3>
          <p>지식의 은박을 야금야금 벗겨내며 정답을 유추하세요. 힌트를 덜 볼수록 당신의 보상이 커집니다.</p>
          <router-link to="/scratch" class="card-link text-pink">스크래치 긁기 →</router-link>
        </div>

        <div class="card glass-panel col-span-3 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-purple-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#a29bfe" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            </div>
            <span class="badge text-purple">Clue</span>
          </div>
          <h3>실마리: 추리하는 지식</h3>
          <p>20명의 요원들이 던져주는 파편화된 실마리를 모아 엉킨 매듭을 풀듯 하나의 정답을 유추해 내세요.</p>
          <router-link to="/silmari" class="card-link text-purple">실마리 풀기 →</router-link>
        </div>

      </div>
    </div>

    <div class="section-group">
      <h3 class="section-header">상상 (Imagination)</h3>
      <div class="grid-container">
        
        <div class="card glass-panel col-span-3 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-cyan-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00e5ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
            </div>
            <span class="badge text-cyan">Mystery</span>
          </div>
          <h3>추리사건의 전말</h3>
          <p>당신은 수사관이 됩니다. 앞뒤가 맞지 않는 기묘한 상황의 감춰진 비하인드 스토리(전말)를 알아내세요.</p>
          <router-link to="/mystery" class="card-link text-cyan">사건 파일 열기 →</router-link>
        </div>

        <div class="card glass-panel col-span-3 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-indigo-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#5f27cd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
            </div>
            <span class="badge text-indigo">AI Receipt</span>
          </div>
          <h3>욕망의 편의점</h3>
          <p>당신의 영혼을 채우는 욕망은 얼마일까요? AI 점장이 발급하는 팩트 폭격 영수증.</p>
          <router-link to="/receipt" class="card-link text-indigo">입장하기 →</router-link>
        </div>

        <div class="card glass-panel col-span-6 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-yellow-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#feca57" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
            </div>
            <span class="badge text-yellow">Award</span>
          </div>
          <h3>뻔뻔한 위원회</h3>
          <p>사소한 핑계도 위대한 업적이 됩니다. AI 위원장이 수여하는 당신만의 뻔뻔한 상장.</p>
          <router-link to="/award" class="card-link text-yellow">상장 받기 →</router-link>
        </div>
      </div>
    </div>

    <div class="section-group">
      <h3 class="section-header">기술 (Technology)</h3>
      <div class="grid-container">
        
        <div class="card glass-panel col-span-2 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-teal-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1abc9c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5"/><path d="M8.5 8.5v.01"/><path d="M15.5 8.5v.01"/><path d="M12 16a4 4 0 0 0 4-2.4"/></svg>
            </div>
            <span class="badge text-teal">Memory</span>
          </div>
          <h3>침팬지보다 낫겠지</h3>
          <p>당신의 순간 기억력은 침팬지를 이길 수 있을까요? 순식간에 사라지는 숫자를 기억해 보세요.</p>
          <router-link to="/chimpanzee" class="card-link text-teal">도전하기 →</router-link>
        </div>

        <div class="card glass-panel col-span-2 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-orange-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffa502" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="2" ry="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/></svg>
            </div>
            <span class="badge text-orange">Math</span>
          </div>
          <h3>수포자 5초 전</h3>
          <p>당신은 수학을 포기하셨습니까? 단 5초 안에 정답을 찾아내는 극한의 뇌지컬 테스트.</p>
          <router-link to="/math-give-up" class="card-link text-orange">수학 풀기 →</router-link>
        </div>

        <div class="card glass-panel col-span-2 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-lime-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#32ff7e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="12" y1="8" x2="12" y2="16"/></svg>
            </div>
            <span class="badge text-lime">Arithmetic</span>
          </div>
          <h3>아주 쉬운 덧셈, 뺄셈</h3>
          <p>세상에서 가장 쉬운 연산 게임. 0.5초마다 나타나는 숫자를 누적해서 암산하는 하드코어 뇌지컬 게임입니다.</p>
          <router-link to="/easy-math" class="card-link text-lime">암산하기 →</router-link>
        </div>

        <div class="card glass-panel col-span-2 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-blue-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#48dbfb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            </div>
            <span class="badge text-blue">Focus</span>
          </div>
          <h3>인증번호 외우기</h3>
          <p>무작위 문자를 기억하고 맞히는 인간 캡챠 인증 테스트. 작업 기억력을 확인하세요.</p>
          <router-link to="/auth-code" class="card-link text-blue">인증하기 →</router-link>
        </div>

        <div class="card glass-panel col-span-2 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-blue-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#48dbfb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
            </div>
            <span class="badge text-blue">Exam</span>
          </div>
          <h3>디지털 신체검사</h3>
          <p>마우스와 터치만으로 디지털 감각 나이를 측정합니다. 길이, 각도, 색감 테스트.</p>
          <router-link to="/physical-exam" class="card-link text-blue">검사 시작 →</router-link>
        </div>

        <div class="card glass-panel col-span-2 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-pink-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ff7979" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>
            </div>
            <span class="badge text-pink">Reflex</span>
          </div>
          <h3>그걸 못 맞춰?</h3>
          <p>동체시력과 리듬감을 테스트해보세요. 오차 0px에 도전하는 인간 144Hz 판별기.</p>
          <router-link to="/cant-match" class="card-link text-pink">도전하기 →</router-link>
        </div>
      </div>
    </div>

    <div class="section-group">
      <h3 class="section-header">지원 (Support)</h3>
      <div class="grid-container">
        <div class="card glass-panel col-span-3 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-pink-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ff4757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            </div>
            <span class="badge text-pink">Business</span>
          </div>
          <h3>함께 만드는 가치</h3>
          <p>말로만랩의 독창적인 콘텐츠와 기술력을 귀사의 비즈니스에 접목해보세요.</p>
          <router-link to="/partnership" class="card-link text-pink">제휴 제안하기 →</router-link>
        </div>

        <div class="card glass-panel col-span-3 group">
          <div class="card-header-row">
            <div class="card-icon-bg bg-yellow-soft">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#feca57" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
            </div>
            <span class="badge text-yellow">Development</span>
          </div>
          <h3>기술과 혁신을 향한 소통</h3>
          <p>획기적인 아이디어를 개발하고 싶으신가요? 말로만랩 개발팀은 언제나 여러분의 목소리에 귀 기울이고 있습니다.</p>
          <router-link to="/devinquiry" class="card-link text-yellow">개발 문의 남기기 →</router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
/* 박스 사이징 전역 적용 (너비 짤림 방지) */
.sections-container, 
.section-group, 
.grid-container, 
.glass-panel {
  box-sizing: border-box;
}

.sections-container {
  width: 100%;
}

.section-group { margin-bottom: 60px; }
.section-header {
  font-size: 1.2rem; color: #636e72; font-weight: 700;
  text-transform: uppercase; letter-spacing: 1px;
  margin-bottom: 20px; padding-left: 4px;
  border-left: 3px solid #00f3ff; line-height: 1; padding-left: 12px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 24px;
}

.glass-panel {
  background: rgba(19, 19, 43, 0.85); 
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  padding: 32px;
  transition: transform 0.2s ease, border-color 0.2s ease;
  display: flex; flex-direction: column;
  will-change: transform; 
  width: 100%; 
}

.glass-panel:hover {
  transform: translateY(-5px);
  border-color: rgba(255, 255, 255, 0.25);
}

.card-header-row {
  display: flex;
  align-items: center;
  gap: 14px; 
  margin-bottom: 20px;
}

.card-icon-bg {
  width: 48px; height: 48px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
}

.badge {
  display: inline-block; 
  padding: 6px 14px; 
  border-radius: 20px; 
  font-size: 0.85rem; 
  font-weight: 700; 
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.col-span-3 { grid-column: span 3; }
.col-span-2 { grid-column: span 2; }
.col-span-6 { grid-column: span 6; }

h3 { color: white; font-size: 1.5rem; font-weight: 700; margin: 8px 0 12px; }

p { 
  color: #94a3b8; 
  font-size: 1rem; 
  line-height: 1.5; 
  margin-bottom: 24px; 
  flex-grow: 1; 
  word-break: keep-all; 
  overflow-wrap: break-word;
}

/* 배경색 유틸리티 */
.bg-red-soft { background: rgba(255, 46, 99, 0.1); }
.bg-cyan-soft { background: rgba(0, 243, 255, 0.1); }
.bg-purple-soft { background: rgba(188, 19, 254, 0.1); }
.bg-green-soft { background: rgba(46, 213, 115, 0.1); }
.bg-orange-soft { background: rgba(255, 165, 2, 0.1); }
.bg-indigo-soft { background: rgba(95, 39, 205, 0.1); }
.bg-yellow-soft { background: rgba(236, 204, 104, 0.1); }
.bg-pink-soft { background: rgba(255, 71, 87, 0.1); }
.bg-teal-soft { background: rgba(26, 188, 156, 0.1); }
.bg-blue-soft { background: rgba(72, 219, 251, 0.1); }
.bg-gray-soft { background: rgba(178, 190, 195, 0.1); }
.bg-mint-soft { background: rgba(0, 184, 148, 0.1); }
/* ⭐️ 추가된 라임색 유틸리티 */
.bg-lime-soft { background: rgba(50, 255, 126, 0.1); }

/* 텍스트 색상 유틸리티 */
.text-red { color: #ff2e63; }
.text-cyan { color: #00f3ff; }
.text-purple { color: #bc13fe; }
.text-green { color: #2ed573; }
.text-orange { color: #ffa502; }
.text-indigo { color: #5f27cd; }
.text-yellow { color: #eccc68; }
.text-pink { color: #ff7979; }
.text-teal { color: #1abc9c; }
.text-blue { color: #48dbfb; }
.text-gray { color: #b2bec3; }
.text-mint { color: #00b894; }
/* ⭐️ 추가된 라임색 유틸리티 */
.text-lime { color: #32ff7e; }

.card-link { font-weight: 600; text-decoration: none; display: inline-block; margin-top: auto; transition: opacity 0.2s; }
.card-link:hover { opacity: 0.8; }

/* 모바일 반응형 너비 짤림 해결 */
@media (max-width: 768px) {
  .grid-container { 
    display: flex; 
    flex-direction: column; 
    gap: 16px; 
  }
  
  .glass-panel {
    padding: 24px 20px; 
    width: 100%;
  }

  .col-span-3, .col-span-2, .col-span-6 { 
    width: 100%; 
    grid-column: auto;
  }
}
</style>